import { FC, ReactNode } from "react";

import { VnBox } from "@/components/VnBox";
import { OnboardingScreenType } from "@/domain/onboarding";

type OnboardingStepFramePropsType = OnboardingScreenType & {
  children: ReactNode;
};

// Paints the standard onboarding backgrounds under the floating header (maroon)
// and footer controls (page background with a top border), and places the
// step's content in the space between them.
export const OnboardingStepFrame: FC<OnboardingStepFramePropsType> = ({
  width,
  headerHeight,
  footerHeight,
  children,
}) => (
  <VnBox style={{ width }} className="flex-1">
    <VnBox className="bg-sidebar" style={{ height: headerHeight }} />
    <VnBox className="flex-1">{children}</VnBox>
    <VnBox
      className="bg-background border-border border-t"
      style={{ height: footerHeight }}
    />
  </VnBox>
);
